const API_BASE_URL = process.env.BASE_URL

export const BYTESCALE_ENDPOINTS = {
    JWT: API_BASE_URL + "/api/bytescale/jwt/",
}
